import React from 'react';
import styled from 'styled-components';

export const InvertedImage = styled.img`
  filter: invert(100%);
`;